"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.regexp.split");
var _slicedToArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.string.starts-with");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _handsontable = _interopRequireDefault(require("handsontable"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _SailScheduleOne = _interopRequireDefault(require("@/components/SailScheduleOne"));
var _vue = require("@handsontable/vue");
var _vuex = require("vuex");
var _batchReservationNb = _interopRequireDefault(require("../blExchangeAppointment/components/batchReservationNb"));
var _batchReservationQd = _interopRequireDefault(require("../blExchangeAppointment/components/batchReservationQd"));
var _batchReservationSk = _interopRequireDefault(require("../blExchangeAppointment/components/batchReservationSk"));
var _batchReservationXg = _interopRequireDefault(require("../blExchangeAppointment/components/batchReservationXg"));
var _batchReservationXm = _interopRequireDefault(require("../blExchangeAppointment/components/batchReservationXm"));
var _searchContainerPh = _interopRequireDefault(require("../blExchangeAppointment/components/searchContainerPh"));
var _confirmPrintingDialog = _interopRequireDefault(require("../blExchangeAppointment/components/confirmPrintingDialog"));
var _appointmentHistory = require("@/api/appointmentHistory/appointmentHistory");
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _utils = require("@/utils");
var _ClearableTextInput = _interopRequireDefault(require("@/components/ClearableTextInput"));
var _validate = require("@/utils/validate");
var _updatePickCtnDialog = _interopRequireDefault(require("@/views/import/blExchangeAppointment/components/updatePickCtnDialog.vue"));
var _confirmPrintingDialogPh = _interopRequireDefault(require("@/views/import/blExchangeAppointment/components/confirmPrintingDialogPh.vue"));
var _searchContainerPh2 = _interopRequireDefault(require("@/views/import/blExchangeAppointment/components/searchContainerPh2.vue"));
var _batchReservationPhSaveDialog = _interopRequireDefault(require("@/views/import/blExchangeAppointment/components/batchReservationPhSaveDialog.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AppointmentHistory',
  components: {
    BatchReservationPhSaveDialog: _batchReservationPhSaveDialog.default,
    SearchContainerPh2: _searchContainerPh2.default,
    ConfirmPrintingDialogPh: _confirmPrintingDialogPh.default,
    UpdatePickCtnDialog: _updatePickCtnDialog.default,
    HotColumn: _vue.HotColumn,
    Pagination: _Pagination.default,
    sailSchedule: _SailScheduleOne.default,
    batchReservationNb: _batchReservationNb.default,
    batchReservationQd: _batchReservationQd.default,
    batchReservationSk: _batchReservationSk.default,
    batchReservationXg: _batchReservationXg.default,
    batchReservationXm: _batchReservationXm.default,
    filterColumn: _index.default,
    ClearableTextInput: _ClearableTextInput.default
  },
  data: function data() {
    return {
      inSailScheduleDialogVisible: false,
      outSailScheduleDialogVisible: false,
      batchReservationNbVisible: false,
      // 宁波初始化弹窗状态
      batchReservationPhVisible: false,
      // PH初始化弹窗状态
      batchReservationQdVisible: false,
      // 青岛初始化弹窗状态
      batchReservationSkVisible: false,
      // 蛇口初始化弹窗状态
      batchReservationXgVisible: false,
      // 新港初始化弹窗状态
      batchReservationXmVisible: false,
      // 厦门初始化弹窗状态
      updatePickCtnDateDialogVisible: false,
      searchContainerDialogVisible: false,
      confirmPrintingDialogVisible: false,
      printDialog: {},
      portCodes: [],
      // 用户港口权限
      dataTime: [],
      tableData: [],
      params: [],
      vvLBlNo: '',
      edoCreditId: '',
      cancelEdoCreditIds: [],
      paymentStatus: '',
      forespeakStatus: '',
      formDialog: {},
      forespeakBlNo: [],
      total: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 10,
        namedParameters: {}
      },
      filterForm: {
        inVesselCode: '',
        inVesselName: '',
        inVoyageNo: '',
        inVoyageLeg: '',
        outVesselCode: '',
        outVoyageNo: '',
        outVoyageName: '',
        outVoyageLeg: '',
        blNo: '',
        fromDate: '',
        toDate: '',
        portCode: ''
      },
      hotSettings: {
        dragCheck: true,
        height: 'calc(100px)',
        width: 'auto',
        overflow: 'hidden',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false,
        hiddenColumns: {
          columns: [],
          indicators: false
        }
      },
      paymentStatusList: [],
      paymentStatusPHList: [],
      edoPaymentMethod: [],
      forespeakStatusList: [],
      phBankList: [],
      fileStatusList: [],
      ecmNgbEdoOwnerType: [],
      docEdoFileStatusMap: new Map(),
      deliveryReleaseFlagMap: new Map(),
      loading: null,
      del: null,
      curBlNo: [],
      rules: {
        portCode: [{
          required: true,
          message: this.$t('blExchangeAppointment.portCodeEmpty'),
          tigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    var _this = this;
    this.deliveryReleaseFlagMap.set('0', {
      displayValueCn: '否',
      displayValue: 'No'
    });
    this.deliveryReleaseFlagMap.set(0, {
      displayValueCn: '否',
      displayValue: 'No'
    });
    this.deliveryReleaseFlagMap.set('1', {
      displayValueCn: '是',
      displayValue: 'Yes'
    });
    this.deliveryReleaseFlagMap.set(1, {
      displayValueCn: '是',
      displayValue: 'Yes'
    });
    this.$dictionary.get(['EDO_PAYMENT_METHOD', 'DOC_PAYMENT_STATUS', 'DOC_FORESPEAK_STATUS', 'ECM_NGB_EDO_OWNER_TYPE', 'PH_EDO_BANK_LIST', 'DOC_EDO_FILE_STATUS', 'DOC_PAYMENT_STATUS_PH'], true).then(function (res) {
      _this.edoPaymentMethod = res.EDO_PAYMENT_METHOD ? res.EDO_PAYMENT_METHOD : [];
      _this.paymentStatusList = res.DOC_PAYMENT_STATUS ? res.DOC_PAYMENT_STATUS : [];
      _this.paymentStatusPHList = res.DOC_PAYMENT_STATUS_PH ? res.DOC_PAYMENT_STATUS_PH : [];
      _this.forespeakStatusList = res.DOC_FORESPEAK_STATUS ? res.DOC_FORESPEAK_STATUS : [];
      _this.ecmNgbEdoOwnerType = res.ECM_NGB_EDO_OWNER_TYPE ? res.ECM_NGB_EDO_OWNER_TYPE : [];
      _this.fileStatusList = res.DOC_EDO_FILE_STATUS ? res.DOC_EDO_FILE_STATUS : [];
      _this.phBankList = res.PH_EDO_BANK_LIST ? res.PH_EDO_BANK_LIST : [];
      _this.docEdoFileStatusMap.clear();
      if (_this.fileStatusList && _this.fileStatusList.length > 0) {
        _this.fileStatusList.forEach(function (item) {
          _this.docEdoFileStatusMap.set(item.codeValue, {
            displayValueCn: item.displayValueCn,
            displayValue: item.displayValue
          });
          var numCodeValue = Number(item.codeValue);
          if (!isNaN(numCodeValue) && String(numCodeValue) === item.codeValue) {
            _this.docEdoFileStatusMap.set(numCodeValue, {
              displayValueCn: item.displayValueCn,
              displayValue: item.displayValue
            });
          }
        });
      }
    });
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  watch: {
    'filterForm.portCode': function filterFormPortCode(newVal, oldVal) {
      var _this2 = this;
      this.$nextTick(function () {
        setTimeout(function () {
          _this2.toggleHiddenColumns();
        }, 300);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;
    this.querySysAccountPort();
    this.$nextTick(function () {
      setTimeout(function () {
        _this3.resizeHotTable();
        _this3.toggleHiddenColumns();
      }, 300);
    });
  },
  methods: {
    querySysAccountPort: function querySysAccountPort() {
      var _this4 = this;
      (0, _blExchangeAppointment.querySysAccountPort)().then(function (res) {
        if (res.success) {
          _this4.portCodes = res.data;
        }
      }).catch(function (error) {});
    },
    // 上一步
    handlePreviousStep: function handlePreviousStep() {
      this.searchContainerDialogVisible = true;
      this.confirmPrintingDialogVisible = false;
    },
    handleNextStep: function handleNextStep() {
      this.confirmPrintingDialogVisible = false;
      this.batchReservationPhVisible = true;
    },
    handleNextContainer: function handleNextContainer() {
      this.searchContainerDialogVisible = false;
      this.confirmPrintingDialogVisible = true;
    },
    handleNextConfirmPrint: function handleNextConfirmPrint(tableData, resData) {
      // 正确传递 resData（包含 billNo 和 ecmDemurrageBillDetails 的数据）
      this.params = resData;
      this.searchContainerDialogVisible = false;
      this.confirmPrintingDialogVisible = true;
    },
    handleCloseReservationNb: function handleCloseReservationNb() {
      this.batchReservationNbVisible = false;
      this.handleSearch();
    },
    handleCloseReservationXm: function handleCloseReservationXm() {
      this.batchReservationXmVisible = false;
      this.handleSearch();
    },
    handleCloseReservationSk: function handleCloseReservationSk() {
      this.batchReservationSkVisible = false;
      this.handleSearch();
    },
    handleCloseReservationQd: function handleCloseReservationQd() {
      this.batchReservationQdVisible = false;
      this.handleSearch();
    },
    handleCloseReservationXg: function handleCloseReservationXg() {
      this.batchReservationXgVisible = false;
      this.handleSearch();
    },
    handleOpenINVessel: function handleOpenINVessel() {
      this.inSailScheduleDialogVisible = true;
    },
    handleOpenOutVessel: function handleOpenOutVessel() {
      this.outSailScheduleDialogVisible = true;
    },
    selectionInChange: function selectionInChange(row) {
      this.inSailScheduleDialogVisible = false;
      this.filterForm.inVesselCode = row.vesselCode;
      this.filterForm.inVesselName = row.vesselName;
      this.filterForm.inVoyageNo = row.voyageNo;
      this.filterForm.inVoyageLeg = row.voyageLeg;
    },
    selectionOutChange: function selectionOutChange(row) {
      this.outSailScheduleDialogVisible = false;
      this.filterForm.outVesselCode = row.vesselCode;
      this.filterForm.outVoyageName = row.vesselName;
      this.filterForm.outVoyageNo = row.voyageNo;
      this.filterForm.outVoyageLeg = row.voyageLeg;
    },
    handleBatchPrint: function handleBatchPrint() {
      var _this5 = this;
      // 获取勾选行
      var hotTableSelections = this.$refs.hotTable.getSelections();
      // 判断是否存在勾选数据
      if (hotTableSelections.length < 1) {
        this.$message.error(this.$t('home.warning'));
        return;
      }
      var firstPort = hotTableSelections[0].del;
      var hasDifferentPort = hotTableSelections.some(function (selection) {
        return selection.del !== firstPort;
      });
      if (hasDifferentPort) {
        this.$message.error(this.$t('appointmentHistory.notSamePort'));
        return;
      }
      if (firstPort.startsWith('PH')) {
        // PH开头港口的批量打印逻辑 - 添加换单校验
        var unReleasedBlNos = hotTableSelections.filter(function (selection) {
          return selection.deliveryReleaseFlag !== '1';
        }).map(function (selection) {
          return selection.blNo;
        });
        if (unReleasedBlNos.length > 0) {
          this.$message.warning(this.$t('blExchangeAppointment.cannotPrintEdoByPh', {
            blNos: unReleasedBlNos.join(', ')
          }));
          return;
        }
        var bookingHeadIds = hotTableSelections.map(function (selection) {
          return selection.bookingHeadId;
        }).join(',');
        var blNos = hotTableSelections.map(function (selection) {
          return selection.blNo;
        }).join(',');
        var portCode = firstPort;
        this.loading = (0, _utils.load)();
        (0, _appointmentHistory.downDocReleaseOrderPh)(bookingHeadIds, blNos, portCode).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res], {
            type: 'application/pdf'
          }));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', 'doc_release_order_batch.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch(function (error) {
          _this5.$message.error('批量打印失败');
          console.error('批量打印错误:', error);
        }).finally(function () {
          _this5.loading.close();
        });
      } else if (firstPort === 'CNTAO') {
        var edoCreditIds = hotTableSelections.map(function (selection) {
          return selection.edoCreditId;
        });
        this.loading = (0, _utils.load)();
        (0, _appointmentHistory.exportNewQDs)(edoCreditIds).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res], {
            type: 'application/pdf'
          }));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', '进口集装箱货物信息单.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).finally(function () {
          _this5.loading.close();
        });
      } else if (firstPort === 'CNSHK') {
        var _blNos = hotTableSelections.filter(function (item) {
          return !(0, _validate.validateNull)(item.checkCode);
        }).map(function (it) {
          return it.blNo;
        });
        var unableBlNos = hotTableSelections.filter(function (item) {
          return (0, _validate.validateNull)(item.checkCode);
        }).map(function (it) {
          return it.blNo;
        });
        if (!(0, _validate.validateNull)(_blNos)) {
          this.loading = (0, _utils.load)();
          (0, _appointmentHistory.exportEdoSK)(_blNos).then(function (res) {
            var url = window.URL.createObjectURL(new Blob([res], {
              type: 'application/pdf'
            }));
            var link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', '进口集装箱货物信息单.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }).finally(function () {
            _this5.loading.close();
          });
        }
        if (!(0, _validate.validateNull)(unableBlNos)) {
          this.$message.warning(unableBlNos.toString() + '  ' + this.$t('appointmentHistory.cantPrint'));
        }
      } else {
        this.$message.error(this.$t('appointmentHistory.notBatchPrint'));
      }
    },
    handleReset: function handleReset() {
      for (var key in this.filterForm) {
        this.filterForm[key] = '';
      }
      this.dataTime = [];
      this.listQuery.currentPage = 1;
      // this.listQuery.pageSize = 10;
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      var _this6 = this;
      if (this.filterForm.inVesselCode == '' && this.filterForm.inVoyageNo == '' && this.filterForm.inVoyageLeg == '' && this.filterForm.outVesselCode == '' && this.filterForm.outVoyageNo == '' && this.filterForm.outVoyageLeg == '' && (this.filterForm.fromDate == '' || this.filterForm.toDate == '') && this.filterForm.blNo == '') {
        this.$message.error(this.$t('appointmentHistory.searchNotNull'));
        return;
      }
      this.listQuery.namedParameters = this.filterForm;
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          _this6.loading = (0, _utils.load)();
          (0, _appointmentHistory.searchHistory)(_this6.listQuery).then(function (res) {
            console.log(res);
            _this6.total = res.data.totalRecord;
            var records = (res.data.records || []).map(function (record) {
              var statusInfo = _this6.docEdoFileStatusMap.get(record.attStatus);
              var attDisplayValue = record.attStatus;
              if (statusInfo) {
                attDisplayValue = _this6.language === 'zh' ? statusInfo.displayValueCn : statusInfo.displayValue;
              }
              var flagInfo = _this6.deliveryReleaseFlagMap.get(record.deliveryReleaseFlag);
              var deliveryReleaseFlagDisplay = record.deliveryReleaseFlag;
              if (flagInfo) {
                deliveryReleaseFlagDisplay = _this6.language === 'zh' ? flagInfo.displayValueCn : flagInfo.displayValue;
              }
              return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, record), {}, {
                attachmentAuditDisplay: attDisplayValue,
                deliveryReleaseFlagDisplay: deliveryReleaseFlagDisplay
              });
            });
            _this6.tableData = records;
            if (_this6.tableData.length != 0) {
              _this6.hotSettings.height = 'calc(100vh - 420px)';
            }
            _this6.$nextTick(function () {
              setTimeout(function () {
                if (_this6.$refs.hotTable && _this6.$refs.hotTable.hotInstance) {
                  _this6.$refs.hotTable.hotInstance.loadData(_this6.tableData);
                  _this6.resizeHotTable();
                  _this6.toggleHiddenColumns();
                }
              }, 300);
            });
          }).finally(function () {
            _this6.loading.close();
          });
        }
      });
    },
    handleDateRangeChange: function handleDateRangeChange(dates) {
      var _dates = (0, _slicedToArray2.default)(dates, 2),
        startDate = _dates[0],
        endDate = _dates[1];
      this.filterForm.fromDate = startDate;
      this.filterForm.toDate = endDate;
    },
    columnRenderer: function columnRenderer(instance, td, row, col, prop, value, cellProperties) {
      switch (value) {
        case 0:
          td.innerHTML = this.$t('blExchangeAppointment.unSend');
          break;
        case 1:
          td.innerHTML = this.$t('blExchangeAppointment.send');
          break;
        default:
          td.innerHTML = value;
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    forespeakStatusRenderer: function forespeakStatusRenderer(instance, td, row, col, prop, value, cellProperties) {
      var _this7 = this;
      // 清空单元格内容
      _handsontable.default.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      // 设置link的文本和点击事件
      if (value === 1) {
        link.innerText = this.$t('blExchangeAppointment.reserved');
        link.addEventListener('click', function () {
          return _this7.handleViewDetail(row);
        });
      } else if (value === 2) {
        link.innerText = this.$t('blExchangeAppointment.reservationSaved');
        link.addEventListener('click', function () {
          return _this7.handleViewDetail(row);
        });
      } else {
        link.innerText = this.$t('blExchangeAppointment.notReserved');
        link.addEventListener('click', function () {
          return _this7.handleViewDetail(row);
        });
      }

      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    handleViewDetail: function handleViewDetail(row) {
      var selectedRow = this.$refs.hotTable.getSelected();
      this.vvLBlNo = "VVL:".concat(selectedRow.outVesselCode, "/").concat(selectedRow.outVoyageNo).concat(selectedRow.outVoyageLeg, ",BL:").concat(selectedRow.blNo);
      this.forespeakBlNo = selectedRow.blNo.split(',');
      this.edoCreditId = selectedRow.edoCreditId;
      var del = selectedRow.del;
      // 蛇口港不需要校验付款状态
      if (del === 'CNSHK' && selectedRow.paymentStatus === 0) {
        this.$message.error(this.$t('blExchangeAppointment.manifestUnpaid'));
        return;
      }
      this.setDialogVisible(del);
    },
    setDialogVisible: function setDialogVisible(firstPort) {
      this.del = firstPort;
      var portDialogMapping = {
        'CNNGB': 'batchReservationNbVisible',
        'CNTAO': 'batchReservationQdVisible',
        'CNSHK': 'batchReservationSkVisible',
        'CNTXG': 'batchReservationXgVisible',
        'CNXMN': 'batchReservationXmVisible'
      };
      if (firstPort.startsWith('PH')) {
        // this.searchContainerDialogVisible = true;
        this.batchReservationPhVisible = true;
      } else if (portDialogMapping[firstPort]) {
        this[portDialogMapping[firstPort]] = true;
      } else {
        console.warn("Unknown port: ".concat(firstPort));
      }
    },
    batchCancelAppointment: function batchCancelAppointment() {
      // 获取勾选行
      var hotTableSelections = this.$refs.hotTable.getSelections();
      // 判断是否存在勾选数据
      if (hotTableSelections.length < 1) {
        this.$message.error(this.$t('blExchangeAppointment.pleaseCheckData'));
        return;
      }
      var firstPort = hotTableSelections[0].del;
      var hasDifferentPort = hotTableSelections.some(function (selection) {
        return selection.del !== firstPort;
      });
      if (hasDifferentPort) {
        this.$message.error(this.$t('appointmentHistory.notSamePort'));
        return;
      }
      var _iterator = (0, _createForOfIteratorHelper2.default)(hotTableSelections),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var selection = _step.value;
          // 未预约不能取消预约
          if (selection.forespeakStatus === 0) {
            this.$message.error(selection.blNo + this.$t('appointmentHistory.notBookedCannotCancel'));
            return;
          }
          // 已发送EDO，预约信息不可修改
          if (selection.edoSentStatus == 1) {
            this.$message.error(selection.blNo + this.$t('blExchangeAppointment.edosentstatusNotEdit'));
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.edoCreditId = '';
      this.cancelEdoCreditIds = hotTableSelections.map(function (selection) {
        return selection.edoCreditId;
      });
      var vvl = hotTableSelections.map(function (selection) {
        return "VVL:".concat(selection.outVesselCode, "/").concat(selection.outVoyageNo).concat(selection.outVoyageLeg, ",BL:").concat(selection.blNo);
      });
      this.vvLBlNo = vvl.join(',\n');
      this.paymentStatus = hotTableSelections[0].paymentStatus;
      this.forespeakStatus = hotTableSelections[0].forespeakStatus;
      this.setDialogVisible(firstPort);
    },
    // columnRendererDem
    columnRendererDem: function columnRendererDem(instance, td, row, col, prop, value, cellProperties) {
      var _this8 = this;
      // 清空单元格内容
      _handsontable.default.dom.empty(td);
      // 创建一个div元素作为按钮容器
      var div = document.createElement('div');
      div.className = 'opt-group';

      // 创建一个el-link元素
      var link = document.createElement('a');
      link.className = 'iconBtn opt-button';
      link.style.textDecoration = 'none';
      link.style.color = '#409EFF';
      var selectRow = this.$refs.hotTable.getSelected();
      console.log(selectRow, '88888');
      if (selectRow && selectRow.del.startsWith('PH')) {
        link.innerText = 'view';
        link.addEventListener('click', function () {
          return _this8.handleView(selectRow);
        });
      }

      // 将link添加到div容器中
      div.appendChild(link);

      // 将div容器添加到单元格中
      td.appendChild(div);

      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    handleView: function handleView(selectRow) {
      this.printDialog = selectRow;
      this.confirmPrintingDialogVisible = true;
    },
    columnRendererPrint: function columnRendererPrint(instance, td, row, col, prop, value, cellProperties) {
      var _this9 = this;
      if (this.tableData[row].del === 'CNSHK' && (0, _validate.validateNull)(this.tableData[row].checkCode)) {} else {
        // 清空单元格内容
        _handsontable.default.dom.empty(td);
        // 创建一个div元素作为按钮容器
        var div = document.createElement('div');
        div.className = 'opt-group';

        // 创建一个el-link元素
        var link = document.createElement('a');
        link.className = 'iconBtn opt-button';
        link.style.textDecoration = 'none';
        link.style.color = '#409EFF';
        link.innerText = this.$t('blExchangeAppointment.downloadPrint');
        link.addEventListener('click', function () {
          return _this9.handlePrint(row);
        });

        // 将link添加到div容器中
        div.appendChild(link);

        // 将div容器添加到单元格中
        td.appendChild(div);

        // 设置单元格样式，使内容居中
        td.style.textAlign = 'center';
        td.style.verticalAlign = 'middle';
        return td;
      }
    },
    columnRendererDownload4Invoice: function columnRendererDownload4Invoice(instance, td, row, col, prop, value, cellProperties) {
      var _this10 = this;
      if (this.tableData[row].del.startsWith('PH') && (0, _validate.validateNull)(this.tableData[row].checkCode)) {
        // 清空单元格内容
        _handsontable.default.dom.empty(td);
        // 创建一个div元素作为按钮容器
        var div = document.createElement('div');
        div.className = 'opt-group';

        // 创建一个el-link元素
        var link = document.createElement('a');
        link.className = 'iconBtn opt-button';
        link.style.textDecoration = 'none';
        link.style.color = '#409EFF';
        link.innerText = this.$t('blExchangeAppointment.downloadPrint');
        link.addEventListener('click', function () {
          return _this10.handleDownloadInvoice4PH(row);
        });

        // 将link添加到div容器中
        div.appendChild(link);

        // 将div容器添加到单元格中
        td.appendChild(div);

        // 设置单元格样式，使内容居中
        td.style.textAlign = 'center';
        td.style.verticalAlign = 'middle';
        return td;
      }
    },
    columnRendererDownload4AN: function columnRendererDownload4AN(instance, td, row, col, prop, value, cellProperties) {
      var _this11 = this;
      if (this.tableData[row].del.startsWith('PH') && (0, _validate.validateNull)(this.tableData[row].checkCode)) {
        // 清空单元格内容
        _handsontable.default.dom.empty(td);
        // 创建一个div元素作为按钮容器
        var div = document.createElement('div');
        div.className = 'opt-group';

        // 创建一个el-link元素
        var link = document.createElement('a');
        link.className = 'iconBtn opt-button';
        link.style.textDecoration = 'none';
        link.style.color = '#409EFF';
        link.innerText = this.$t('blExchangeAppointment.downloadPrint');
        link.addEventListener('click', function () {
          return _this11.handleDownloadAN4PH(row);
        });

        // 将link添加到div容器中
        div.appendChild(link);

        // 将div容器添加到单元格中
        td.appendChild(div);

        // 设置单元格样式，使内容居中
        td.style.textAlign = 'center';
        td.style.verticalAlign = 'middle';
        return td;
      }
    },
    columnRendererUpdate: function columnRendererUpdate(instance, td, row, col, prop, value, cellProperties) {
      var _this12 = this;
      if (this.tableData[row].del.startsWith('PH') && (0, _validate.validateNull)(this.tableData[row].checkCode)) {
        // 清空单元格内容
        _handsontable.default.dom.empty(td);
        // 创建一个div元素作为按钮容器
        var div = document.createElement('div');
        div.className = 'opt-group';

        // 创建一个el-link元素
        var link = document.createElement('a');
        link.className = 'iconBtn opt-button';
        link.style.textDecoration = 'none';
        link.style.color = '#409EFF';
        link.innerText = this.$t('appointmentHistoryTable.updatePickCtnDate');
        link.addEventListener('click', function () {
          return _this12.updateDate(row);
        });

        // 将link添加到div容器中
        div.appendChild(link);

        // 将div容器添加到单元格中
        td.appendChild(div);

        // 设置单元格样式，使内容居中
        td.style.textAlign = 'center';
        td.style.verticalAlign = 'middle';
        return td;
      }
    },
    handlePrint: function handlePrint(row) {
      var _this13 = this;
      var rowData = this.$refs.hotTable.getSelected();
      console.log(rowData);
      if (rowData.del == 'CNXMN') {
        this.loading = (0, _utils.load)();
        (0, _appointmentHistory.downloadEdoXm)(rowData.bookingHeadId).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res], {
            type: 'application/pdf'
          }));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', '进口集装箱货物信息单.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).finally(function () {
          _this13.loading.close();
        });
      } else if (rowData.del == 'CNTAO') {
        this.loading = (0, _utils.load)();
        (0, _appointmentHistory.exportNewQD)(rowData.edoCreditId).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res], {
            type: 'application/x-execl'
          }));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', 'file.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).finally(function () {
          _this13.loading.close();
        });
      } else if (rowData.del == 'CNTXG' || rowData.del == 'CNNGB') {
        this.loading = (0, _utils.load)();
        (0, _appointmentHistory.exportNew)(rowData.edoCreditId).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res], {
            type: 'application/x-execl'
          }));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', 'file.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).finally(function () {
          _this13.loading.close();
        });
      } else if (rowData.del.substring(0, 2) == 'PH') {
        this.loading = (0, _utils.load)();
        (0, _appointmentHistory.downDocReleaseOrder)(rowData.bookingHeadId, rowData.eta, rowData.blNo, rowData.del).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res], {
            type: 'application/pdf'
          }));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', 'doc_release_order_ph.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).finally(function () {
          _this13.loading.close();
        });
      } else if (rowData.del == 'CNSHK') {
        var blNos = [rowData.blNo];
        this.loading = (0, _utils.load)();
        (0, _appointmentHistory.exportEdoSK)(blNos).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res], {
            type: 'application/pdf'
          }));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', '进口集装箱货物信息单.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).finally(function () {
          _this13.loading.close();
        });
      }
    },
    updateDate: function updateDate(row) {
      // this.updatePickCtnDateDialogVisible = true
      this.searchContainerDialogVisible = true;
      this.curBlNo = [this.tableData[row].blNo];
    },
    handleConfirmPrint: function handleConfirmPrint() {
      this.updatePickCtnDateDialogVisible = false;
    },
    handleDownloadAN4PH: function handleDownloadAN4PH(row) {
      var _this14 = this;
      var rowData = this.$refs.hotTable.getSelected();
      console.log(rowData);
      if (rowData.del.startsWith('PH')) {
        this.loading = (0, _utils.load)();
        (0, _appointmentHistory.downloadAN4PH)(rowData.bookingHeadId, rowData.del).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res], {
            type: 'application/pdf'
          }));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', 'Arrival Notice' + rowData.blNo + '.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).finally(function () {
          _this14.loading.close();
        });
      }
    },
    handleDownloadInvoice4PH: function handleDownloadInvoice4PH(row) {
      var _this15 = this;
      var rowData = this.$refs.hotTable.getSelected();
      console.log(rowData);
      if (rowData.del.startsWith('PH')) {
        this.loading = (0, _utils.load)();
        (0, _appointmentHistory.downloadInvoice4PH)(rowData.blNo).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res], {
            type: 'application/pdf'
          }));
          var link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', 'Invoice ' + rowData.blNo + '.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).finally(function () {
          _this15.loading.close();
        });
      }
    },
    resizeHotTable: function resizeHotTable() {
      if (this.$refs.hotTable && this.$refs.hotTable.hotInstance) {
        this.$refs.hotTable.hotInstance.render();
      }
    },
    toggleHiddenColumns: function toggleHiddenColumns() {
      if (!this.$refs.hotTable || !this.$refs.hotTable.hotInstance) {
        return;
      }
      var hotInstance = this.$refs.hotTable.hotInstance;
      var isPHPort = this.filterForm.portCode && this.filterForm.portCode.startsWith('PH');
      var hiddenColumnsPlugin = hotInstance.getPlugin('hiddenColumns');
      if (!hiddenColumnsPlugin) {
        console.error('hiddenColumns plugin not found for hotTable');
        return;
      }
      try {
        var columnCount = hotInstance.countCols();
        if (columnCount === 0) {
          return; // 表格未完全渲染
        }

        // 先显示所有列以重置状态
        var allColumns = (0, _toConsumableArray2.default)(Array(columnCount).keys());
        hiddenColumnsPlugin.showColumns(allColumns);
        var columnsToHide = [];
        if (isPHPort) {
          // 是 PH 开头时才隐藏
          // 隐藏指定列: 11 12 13 15 18
          var indicesToHide = [];
          if (columnCount > 11) indicesToHide.push(11); // invoiceTitle
          if (columnCount > 12) indicesToHide.push(12); // edoCertifyCode
          if (columnCount > 13) indicesToHide.push(13); // anCode
          if (columnCount > 15) indicesToHide.push(15); // edoSentStatus
          if (columnCount > 18) indicesToHide.push(18); // print
          columnsToHide = indicesToHide;
        } else {
          // 不是PH开头隐藏最后两列: 21, 22
          if (columnCount > 21) columnsToHide.push(21); // attachmentAuditDisplay
          if (columnCount > 22) columnsToHide.push(22); // deliveryReleaseFlagDisplay
        }

        // 使用插件应用隐藏
        if (columnsToHide.length > 0) {
          hiddenColumnsPlugin.hideColumns(columnsToHide);
        }

        // 更新 settings (为了保持一致性)
        this.hotSettings = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.hotSettings), {}, {
          hiddenColumns: {
            columns: columnsToHide,
            indicators: false
          }
        });

        // 触发渲染更新
        hotInstance.render();
        // 防止可能的内存泄漏 (可选)
        // hotInstance.updateSettings({}, false);
      } catch (error) {
        console.error('Error toggling hidden columns for hotTable:', error);
      }
    }
  }
};